<template>
    <div>
        <div class="page d-flex flex-column justify-content-between">
        <!-- * * * * Barra Superior -->
        <header>
            <nav class="navbar navbar-expand shadow">
                <div class="navbar-brand">            
                    <router-link class="" to="/">
                        <img :src="require('@/assets/css/img/logo-fs.png')" class="img-logo d-none d-md-block" alt="logo Fondos Sociales" />
                    </router-link>
                    <router-link class="" to="/">                    
                        <img :src="require('@/assets/css/img/fs.png')" class="fs d-md-none " alt="logo Fondos Sociales" />
                    </router-link>
                    
                </div>

                <div class="topbar d-flex justify-content-between align-items-center w-100">
                    <!-- Topbar Toggle Button-->
                    <button class="btn btn-icon btn-transparent-dark order-1 order-lg-0 mr-lg-2" id="sidebarToggle"
                        type="button" data-toggle="collapse" data-target="#layoutSidebar" aria-controls="layoutSidebar" aria-expanded="false" aria-label="Toggle navigation">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-menu">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    </button>

                      <!-- Logo Telefónica -->
                    <router-link class="mr-auto d-none d-md-block" to="/">                       
                        <img :src="require('@/assets/css/img/logo-telefonica.png')" class="img-logo" alt="logo Telefonica" />
                    </router-link>

                    <div class="my-auto">
                        <span class="topbar-title">Plan Vacaciones {{ ano }}</span>
                    </div>

                    <!-- Topbar User -->
                    <div class="topbar-user d-flex align-items-center ml-auto">
                        <div class="topbar-user-name mr-3 d-none d-md-block">
                            {{ usuario.name }}
                        </div>
                        <b-avatar button variant="primary" @click="desconectar"></b-avatar>

                        <a class="nav-item dropdown mr-3 mr-lg-0 dropdown-user" id="navbarDropdownUserImage"
                            href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <span class="iconify" data-inline="false" data-icon="bx:bxs-user-circle"
                                style="color: #14404d; font-size: 50px;"></span>
                        </a>
                        <!-- User Dropdown-->
                        <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up"
                            aria-labelledby="navbarDropdownUserImage">

                            <a class="dropdown-item" href="#">
                                <div class="dropdown-item-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-settings">
                                        <circle cx="12" cy="12" r="3"></circle>
                                        <path
                                            d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z">
                                        </path>
                                    </svg></div>
                                Cuenta
                            </a>
                            <div class="dropdown-divider"></div>

                            <a class="dropdown-item" href="/">
                                <div class="dropdown-item-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-log-out">
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                        <polyline points="16 17 21 12 16 7"></polyline>
                                        <line x1="21" y1="12" x2="9" y2="12"></line>
                                    </svg></div>
                                Cerrar sesión
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    </div>
       
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'AppHeader',
  components: { //login,
  },
  data() {
    return {        
        ano: '2000'        
       
    }
  },

  created() {

    this.ano=new Date().getFullYear();

  },
  computed: {
    ...mapState(['auth','errores']),

    logueado() {
        return this.auth.logueado;
    },   
    usuario() {
        return this.$store.state.auth.user;
    },

  },
   methods: {       

        desconectar() {
            if (!this.logueado) return;
            //alert('La sesion se ha desconectado ...');
            this.$store.commit('modal',{tit:"Desconectar",msg:"Se ha desconectado de la Sesion"});
            this.$store.commit('login_off');    
            this.$router.push('/');
        },



   }



    
}
</script>